import React from 'react'

const Footer = () => (
  <footer className="container footer">
    <p>
      Made with{' '}
      <a href={'https://www.gatsbyjs.org/'} target={'_blank'} rel="noopener noreferrer">
        Gatsby.js
      </a>
      .<br></br>© Copyright 2020.
    </p>
  </footer>
)

export default Footer
